export default function RacetwRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                `}
            </style>


            <div class="modal fade show" style={{ display: "block", paddingLeft: "0px", marginBottom: "20px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Race 20 - 20</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">
                                                To predict which suit (Spade, Heart, Club, Diamond) gets 5 cards first
                                            </p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p>Hands dealt: Max 17 cards</p>
                                        </div>
                                    </center>

                                    <div>
                                        <center>
                                            <h5>Main Bets</h5>
                                        </center>
                                        <ol>
                                            <li class="lit20">King Spade wins when 5 spades are dealt</li>
                                            <li class="lit20">King Heart wins when 5 hearts are dealt</li>
                                            <li class="lit20">King Club wins when 5 clubs are dealt</li>
                                            <li class="lit20">King Diamond wins when 5 diamonds are dealt</li>
                                            <li class="lit20">Cards: A to Q of all suits</li>
                                        </ol>
                                    </div>

                                    <div>
                                        <center><h3><b>PAYOUT</b></h3></center>
                                        <p class="pt20">
                                            Payout as per the bet placed
                                        </p>
                                        <div>
                                            <div>
                                                <table class="table table-bordered table-sm">
                                                    <tbody>
                                                        <tr>
                                                            <th>King of Spades</th>
                                                            <th>
                                                                1 to 2.85
                                                            </th>
                                                        </tr>
                                                        <tr>
                                                            <th>King of Hearts</th>
                                                            <th>
                                                                1 to 2.85
                                                            </th>
                                                        </tr>

                                                        <tr>
                                                            <th>King of Clubs</th>
                                                            <th> 1 to 2.85</th>
                                                        </tr>

                                                        <tr>
                                                            <th>King of Diamond</th>
                                                            <th>
                                                                1 to 2.85
                                                            </th>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}